module.exports = __webpack_public_path__ + "static/media/theme-logo.30cf729a.svg";